import React from 'react';
import styled, { css } from 'styled-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useConfigTableContext } from '../../../context/config-table-context';

// Icons
import IconPenToSquare from '../../../../../icons/pen-to-square';
import IconTrash from '../../../../../icons/trash';
import IconPenRuler from '../../../../../icons/pen-ruler';
import IconBan from '../../../../../icons/ban';

const StyledDropdownItem = styled(DropdownMenu.Item)`
    display: flex;
    gap: 10px;
    min-width: 150px;
    align-items: center;
    padding: 6px 10px;
    font-size: 14px;
    color: ${props => props.theme.colours.darkGrey};
    cursor: pointer;

    :hover {
        border: none;
        outline: none;
        background-color: #f5f5f5;
        color: ${props => props.theme.colours.offBlackLighter};
    }
`;

const StyledIcon = css`
    height: 15px;
`;

const StyledIconPenToSquare = styled(IconPenToSquare)`
    ${StyledIcon}
`;

const StyledIconPenRuler = styled(IconPenRuler)`
    ${StyledIcon}
`;

const StyledIconTrash = styled(IconTrash)`
    ${StyledIcon}
`;

const StyledIconBan = styled(IconBan)`
    ${StyledIcon}
`;

type ActionDropdownItemProps = {
    rowId: number;
    type: 'edit' | 'edit-secondary' | 'delete' | 'revoke';
    label?: string;
    onClick: (rowId: number) => void;
};

const ActionDropdownItem = ({ rowId, type, label, onClick }: ActionDropdownItemProps) => {
    const { status } = useConfigTableContext();

    const dropdownItem = () => {
        switch (type) {
            case 'edit':
                return (
                    <StyledDropdownItem onSelect={() => onClick(rowId)}>
                        <StyledIconPenToSquare />
                        {label || 'Edit'}
                    </StyledDropdownItem>
                );
            case 'edit-secondary':
                return (
                    <StyledDropdownItem onSelect={() => onClick(rowId)}>
                        <StyledIconPenRuler />
                        {label || 'Edit Rule'}
                    </StyledDropdownItem>
                );
            case 'delete':
                return (
                    <StyledDropdownItem onSelect={() => onClick(rowId)}>
                        <StyledIconTrash />
                        {label || 'Delete'}
                    </StyledDropdownItem>
                );
            case 'revoke':
                return (
                    <StyledDropdownItem onSelect={() => onClick(rowId)}>
                        <StyledIconBan />
                        {label || 'Revoke Access'}
                    </StyledDropdownItem>
                );
        }
    };

    if (status === 'success') {
        return (
            <StyledDropdownItem onSelect={() => onClick(rowId)} data-testid="config-table-action-item">
                {dropdownItem()}
            </StyledDropdownItem>
        );
    }
    return null;
};

export default ActionDropdownItem;
